
//Cookies Consent
require('../shared/cookieconsent-config-dist.js');

// jQuery
window.jQuery = require('jquery');
window.$ = window.jQuery;

require('jquery-lazy');
require('jquery-validation');
require('jquery-validation/dist/localization/messages_ca');

$.validator.setDefaults({
    errorPlacement: function(error, element) {
        error.appendTo( element.parent() );
    },
    focusInvalid: false
});

// Bootstrap
//require('bootstrap');
//require('popper.js');
//require('bootstrap/dist/css/bootstrap.css');

// Fontawesome
//require('@fortawesome/fontawesome-free/css/all.min.css');

// SweetAlert2
//window.Swal = require('sweetalert2');
//require('./swal2.css');

// notifIt!
//require('notifit-js/notifIt/css/notifIt.min.css');
//window.notif = require('notifit-js/notifIt/js/notifIt.min').notif;
//require('./notifit.css');

// Loading indicator
//global.spinner = require('./spinner');

// Loading ajax wrapper
//global.ajaxWrapper = require('./ajax');

// Custom scripts

require('./script-dist.js');

// Custom styles
require('./style-dist.css');
//require('../shared/print.css');
